import { Spinner, Toaster, TooltipProvider } from '@flatfile/baseline'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Outlet, useLocation } from 'react-router-dom'
import { ErrorBoundaryErrorPage } from './components/Shared/CustomErrorComponent'
import { StatusServiceInitializer } from './components/StatusServiceInitializer'
import { SideBar } from './components/SideBar/SideBar'

export function App() {
  const queryClient = new QueryClient()
  const location = useLocation()
  const isFirstLogin = location.pathname.includes('/first-login')

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => (
        <ErrorBoundaryErrorPage error={error} page='App.tsx' logout></ErrorBoundaryErrorPage>
      )}
    >
      <QueryClientProvider client={queryClient}>
        <StatusServiceInitializer />
        <TooltipProvider delayDuration={0} skipDelayDuration={0}>
          <div className='flex h-screen w-full overflow-hidden bg-surface-base'>
            {!isFirstLogin && (
              <div className='shrink-0 w-[275px]'>
                <Suspense
                  fallback={
                    <div className='loading__sidebar bg-surface-base'>
                      <div className='loading_skel_1' style={{ fontWeight: 400 }}>
                        Almost there...
                      </div>
                      <div className='loading_skel_2'></div>
                      <div className='loading_skel_2'></div>
                      <div className='loading_skel_2'></div>
                      <div className='loading_skel_3'></div>
                      <div className='loading_skel_3'></div>
                      <div className='loading_skel_3'></div>
                      <div className='loading_skel_3'></div>
                      <div className='loading_skel_2'></div>
                      <div className='loading_skel_3'></div>
                      <div className='loading_skel_3'></div>
                      <div className='loading_skel_2'></div>
                    </div>
                  }
                >
                  <SideBar />
                </Suspense>
              </div>
            )}

            <Suspense
              fallback={
                <div className='flex items-center justify-center p-8 h-screen w-full bg-surface-base-elevated'>
                  <Spinner size={24} />
                </div>
              }
            >
              <main
                className={`${isFirstLogin ? 'w-full' : 'flex-1 w-0 min-w-0'} h-screen ${isFirstLogin ? '' : 'bg-surface-base-elevated'}`}
              >
                <div className='h-full w-full overflow-auto'>
                  <Outlet />
                </div>
              </main>
            </Suspense>
          </div>
          <Toaster />
        </TooltipProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
